__turbopack_context__.v({
  "actions": "Hero-module__4bCRnq__actions",
  "bg": "Hero-module__4bCRnq__bg",
  "content": "Hero-module__4bCRnq__content",
  "frame": "Hero-module__4bCRnq__frame",
  "hero": "Hero-module__4bCRnq__hero",
  "inner": "Hero-module__4bCRnq__inner",
  "kicker": "Hero-module__4bCRnq__kicker",
  "note": "Hero-module__4bCRnq__note",
  "overlay": "Hero-module__4bCRnq__overlay",
  "primary": "Hero-module__4bCRnq__primary",
  "secondary": "Hero-module__4bCRnq__secondary",
  "subtitle": "Hero-module__4bCRnq__subtitle",
  "title": "Hero-module__4bCRnq__title",
});
